import _classCallCheck from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { Renderer } from '../renderer';

var DepthCopyRenderer =
/*#__PURE__*/
function (_Renderer) {
  _inherits(DepthCopyRenderer, _Renderer);

  function DepthCopyRenderer() {
    _classCallCheck(this, DepthCopyRenderer);

    return _possibleConstructorReturn(this, _getPrototypeOf(DepthCopyRenderer).apply(this, arguments));
  }

  _createClass(DepthCopyRenderer, [{
    key: "customRender",
    value: function customRender(frameInfo, mountBufferFunc, properties) {
      var GL = this.context.gl;
      var sourceOffscreen = this.getOffscreen("source");

      if (!sourceOffscreen) {
        throw new Error("".concat(this.constructor.name, " requires an 'source' offscreen"));
      }

      var textures = sourceOffscreen.render(frameInfo, properties);

      if (!textures.depth) {
        throw new Error("".concat(this.constructor.name, " requires a depth buffer from the 'source' offscreen."));
      }

      mountBufferFunc();
      sourceOffscreen.blitToCurrentFramebuffer(GL.DEPTH_BUFFER_BIT);
    }
  }]);

  return DepthCopyRenderer;
}(Renderer);

export { DepthCopyRenderer as default };